var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRaiseHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.024.467h11.706v11.706H-.024z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.066 3.677c0-.264.232-.575.51-.767.185-.128.41-.17.676-.128v3.195a.266.266 0 1 0 .53 0V1.45c0-.265.29-.533.638-.533.348 0 .53.268.53.533v.533L4.949 5.71c0 .147.121.266.268.266.146 0 .28-.12.28-.266V.65c0-.267.307-.54.623-.54.317 0 .594.276.594.54v1.332l.02 3.728c0 .147.1.266.246.266s.287-.12.287-.266l.02-4.579c0-.017.339-.17.783.14.445.309.514.617.514.882v1.929c0 .106-.038 2.344 0 2.302.282-.317.691-.542 1.229-.674.806-.199 1.367.083 1.543.532a.7.7 0 0 1-.143.78c-.522.53-1.138 1.247-2.326 3.121-.742 1.172-1.963 1.766-3.39 1.766-1.903 0-3.43-1.442-3.43-3.237V3.677z",
    fill: "#FFD044"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaiseHand);
export default __webpack_public_path__ + "static/media/raise-hand.6a90de06.svg";
export { ForwardRef as ReactComponent };